import React, { useState } from 'react';
import Layout from '../common/Layout';
import NotificationsSettings from './NotificationsSettings';
import FrameworksSettings from './frameworks/FrameworksSettings';
import PlanSettings from './PlanSettings';

type TabId = 'profile' | 'account' | 'notifications' | 'frameworks';

interface Tab {
  id: TabId;
  label: string;
}

// Trader theme: plain underline tabs (same idiom as the portfolio section
// tabs, `.ptabs` / `.ptab`), no icons.
const tabs: Tab[] = [
  { id: 'frameworks', label: 'Frameworks' },
  { id: 'profile', label: 'Profile' },
  { id: 'account', label: 'Account Settings' },
  { id: 'notifications', label: 'Notifications' },
];

const SettingsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabId>('frameworks');

  return (
    <Layout>
      <div className="settings-page">
        <div className="settings-header">
          <h1 className="settings-title">Settings</h1>
        </div>

        <div className="ptabs settings-tabs" role="tablist" aria-label="Settings sections">
          {tabs.map((tab) => {
            const on = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={on}
                className={`ptab settings-tab ${on ? 'is-on settings-tab-active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="settings-content">
          {activeTab === 'frameworks' && <FrameworksSettings />}
          {activeTab === 'notifications' && <NotificationsSettings />}
          {activeTab === 'profile' && <PlanSettings />}
          {activeTab === 'account' && (
            <div className="settings-coming-soon">
              <h3>Coming Soon</h3>
              <p>Account settings will be available in a future update.</p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default SettingsPage;
